import { OrderAttributes, SubRouteAttributes, TripAttributes } from '@albatrosdeveloper/ave-models-package';
import SalesOfficeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity';
import RouteGroupAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/route-group/route-group.entity';
import { Component, Inject, signal, TemplateRef, ViewChild } from '@angular/core';
import { SalesOfficeService } from '../../configuration/sales-office/sales-office.service';
import { SubRouteService } from '../../routing/sub-routes/sub-route.service';
import { RouteGroupService } from '../../routing/route-group/route-group.service';
import { TripService } from '../../reports/visits/visit-report/visit-report.service';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { lastValueFrom, Subscription } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { FormatOtherDateHourPipe } from 'app/pipes/other-date.pipe';
import { getCode } from 'app/utils/method';
import { MatSnackBar } from '@angular/material/snack-bar';
import BusinessPartnerAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity';
import { IRequestResult } from 'app/common/interfaces';
import { BusinessPartnerService } from '../../business-partners/business-partner/business-partner.service';
import { IUpdateOrder } from '../../assistant/delivery/loads/interfaces/order.interface';
import { LoadsService } from '../../assistant/delivery/loads/loads.service';
import { OrderSelectionType } from '../../assistant/delivery/loads/enums/typeEdit.enum';
import { SelectionModel } from '@angular/cdk/collections';
import { FuseConfirmationDialogComponent } from '@fuse/services/confirmation/dialog/dialog.component';
import { MatMenuModule } from '@angular/material/menu';
import ShortRouteAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/route/short-route/route.short.entity';
import { TRIP_STATUS_LIST } from 'app/common/enums/trip-status.enum';
import { StatusEnum } from '@albatrosdeveloper/ave-models-package/lib/enums';

@Component({
  selector: 'app-change-trip-order',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatOptionModule,
    MatDatepickerModule,
    FormsModule,
    NgxMatSelectSearchModule,
    NgxMaterialTimepickerModule,
    FormatOtherDateHourPipe,
    MatMenuModule
  ],
  templateUrl: './change-trip-order.component.html',
  styleUrl: './change-trip-order.component.scss'
})
export class ChangeTripOrderComponent {
  getCode = getCode
  StatusEnum = StatusEnum
  editOrderForm: FormGroup;

  //Para editar varios
  selection = new SelectionModel<any>(true, []);
  orderSelectionType: OrderSelectionType = OrderSelectionType.SINGLE;
  isNoOrderSelectionJoin: boolean = false;
  selectHeadOrder: OrderAttributes | null = null;
  selectedOrder: OrderAttributes | null = null;

  salesOfficeList: SalesOfficeAttributes[] = [];
  listFilterSalesOfficeList = signal<SalesOfficeAttributes[]>([]);
  searchOffice = ''

  routeGroup = signal<RouteGroupAttributes[]>([]);

  routesList: SubRouteAttributes[] = [];
  listFilterRoutesList = signal<SubRouteAttributes[]>([]);
  searchRoute = ''

  trips = signal<TripAttributes[]>([]);

  companyId: string | null = null;
  minDate: Date;
  maxDate: Date;
  dateDeliverySubscription!: Subscription;
  minTime: string; // Hora mínima en formato "HH:mm"
  maxTime: String;

  listBusinessPartner: BusinessPartnerAttributes[] = [];
  isOtherRoute: boolean = false;
  statusList = [];

  @ViewChild("confirmDialog") confirmDialog!: TemplateRef<any>;
  @ViewChild("confirmBpDialog") confirmBpDialog!: TemplateRef<any>;
  @ViewChild("orderDetailConfirmDialog") orderDetailConfirmDialog!: TemplateRef<any>;

  constructor(
    private loadService: LoadsService,
    private readonly salesOfficeService: SalesOfficeService,
    private readonly subRouteService: SubRouteService,
    private readonly routeGroupService: RouteGroupService,
    private readonly tripService: TripService,
    private readonly businessPartnerService: BusinessPartnerService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    public readonly dialogRef: MatDialogRef<ChangeTripOrderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.editOrderForm = this.fb.group({
      salesOffice: [''],
      routeGroup: [''],
      route: [''],
      dateLoad: [''],
      timeLoad: [''],
      dateDelivery: [''],
      timeDelivery: [''],
      trip: [null],
    });
  }

  ngAfterViewInit(): void {
    this.dialogRef.updateSize("90%")
    this.initForm()
    this.statusTrip();
  }

  async initForm(): Promise<void> {
    if (this.data) {

      const isMultiple = Array.isArray(this.data) && this.data.length > 0;
      const firstOrder = isMultiple ? this.data[0] : this.data;

      const shipToIds = isMultiple
        ? this.data.map(order => order.shipTo?.id).filter(id => id !== undefined)
        : [firstOrder.shipTo?.id].filter(id => id !== undefined);

      let route = firstOrder.subRoute ? firstOrder.subRoute._id : '';
      let trip = firstOrder.trip ? firstOrder.trip._id : null;

      let deliveryDateTime = firstOrder.deliveryDateTime ?? '';

      this.setDateTimeFromISOToForm(deliveryDateTime as string, 'dateDelivery', 'timeDelivery');

      let salesOffice = null;
      let routeGroup = null;

      if (!route) {
        await this.getAllSalesOfficeList(String(firstOrder.company?._id));
        await this.fetchRouteGroups(String(firstOrder.company?._id));
      } else {
        await this.fetchRoutes(String(firstOrder.company?._id));
        const selectedRoute = this.listFilterRoutesList().find(r => r._id === route);

        if (selectedRoute) {
          salesOffice = selectedRoute.salesOffice?._id ?? null;
          routeGroup = selectedRoute.routeGroup?._id ?? null;
        }

        await this.getAllSalesOfficeList(String(firstOrder.company?._id));
        await this.fetchRouteGroups(String(firstOrder.company?._id));
      }

      this.editOrderForm.patchValue({
        salesOffice: salesOffice,
        routeGroup: routeGroup,
        route: route,
        trip: trip,
      });

      this.getAllBusinesseliveryRoutes(shipToIds)
      await this.fetchTrip();
      if (this.editOrderForm.value.trip) {
        this.changeTrip();
      }
    }
  }

  setDateTimeFromISOToForm(isoString: string, dateF: string = 'dateDelivery', timeF: string = 'timeDelivery'): void {
    if (!isoString) return;

    const dateObject = new Date(isoString);
    //const date = dateObject.toISOString().split('T')[0];

    const hours = dateObject.getHours();
    const minutes = dateObject.getMinutes();
    const formattedTime = this.convertTo12HourFormat(hours, minutes);

    this.editOrderForm.patchValue({
      [dateF]: dateObject,
      [timeF]: formattedTime
    });
  }

  private convertTo12HourFormat(hours: number, minutes: number): string {
    const period = hours >= 12 ? 'PM' : 'AM';
    const hour12 = hours % 12 || 12;

    return `${hour12}:${minutes.toString().padStart(2, '0')} ${period}`;
  }

  getDateTime(dateF: string, timeF: string): Date | null {
    const date = this.editOrderForm.get(dateF)?.value;
    const time = this.editOrderForm.get(timeF)?.value;

    let formattedDate;

    if (typeof date === 'object') {
      let convertedDate = new Date(date);
      let convertedDay = convertedDate.getDate();
      let convertedMonth = (convertedDate.getMonth() + 1);
      let convertedYear = convertedDate.getFullYear();
      formattedDate = `${convertedYear}-${convertedMonth}-${convertedDay}`;
    } else {
      formattedDate = date;
    }


    if (!formattedDate || !time) return null;

    const time24 = this.convertTo24HourFormat(time);
    const [hours, minutes] = time24.split(':').map(Number);

    const dateTime = new Date();
    const [year, month, day] = formattedDate.split('-').map(Number);

    dateTime.setFullYear(year, month - 1, day);
    dateTime.setHours(hours ?? 0, minutes ?? 0, 0, 0);

    return dateTime //.toISOString();
  }

  private convertTo24HourFormat(timeString: string): string {
    if (!timeString) return '';

    const timeRegex = /^(\d{1,2}):(\d{2})\s?(AM|PM)$/i;
    const match = timeString.match(timeRegex);

    if (!match) return '';

    let [_, hours, minutes, period] = match;
    let hourNumber = parseInt(hours, 10);

    if (period.toUpperCase() === 'PM' && hourNumber !== 12) {
      hourNumber += 12;
    } else if (period.toUpperCase() === 'AM' && hourNumber === 12) {
      hourNumber = 0;
    }

    return `${hourNumber.toString().padStart(2, '0')}:${minutes}`;
  }

  isValidDeliveryDay(date: string): Promise<boolean> {
    return new Promise((resolve) => {
      if (!date) {
        resolve(true);
        return;
      }

      const selectedDate = new Date(date);
      const selectedDayValue = selectedDate.getDay() === 0 ? 7 : selectedDate.getDay(); // Ajustar Domingo (0) a 7

      const businessPartner: any = this.listBusinessPartner.find((bp: any) => bp.deliverySubRoutes);

      if (!businessPartner || !Array.isArray(businessPartner.deliverySubRoutes) || businessPartner.deliverySubRoutes.length === 0) {
        resolve(true); // Si no hay subrutas, permitir la fecha
        return;
      }

      // Obtener los días permitidos de todas las `deliverySubRoutes`
      const allowedDays = businessPartner.deliverySubRoutes
        ?.flatMap((subRoute: any) => subRoute.frecuencies?.flatMap((freq: any) => freq.days) || [])
        .filter((value: number, index: number, self: number[]) => self.indexOf(value) === index); // Eliminar duplicados

      if (!allowedDays.includes(selectedDayValue)) {
        this.dialog.open(this.confirmDialog, {
          data: { title: 'Advertencia', message: 'El o los clientes indicados no se visitan en el día seleccionado' },
          panelClass: "delete-modal",
          disableClose: true
        }).afterClosed().subscribe(() => {
          resolve(true);
        });
      } else {
        resolve(true);
      }
    });
  }

  getInvalidShipTo(orders: OrderAttributes): { shipToName: string; serial: string }[] {
    const routeForm = this.routesList.find(subRoute => String(subRoute._id) === this.editOrderForm.value.route)?.
      routes.map(route => String(route._id)) ?? [];

    // const ordersToCheck = [orders];
    const ordersToCheck = Array.isArray(this.data)
      ? this.data
      : [orders];


    return ordersToCheck
      .filter(order => {
        const belongsToRoute = this.listBusinessPartner.some(bp => {
          return bp.id === order.shipTo.id &&
            bp.routes && bp.routes.some(route => routeForm.includes(String(route._id))); // Aquí está el cambio
        });
        return !belongsToRoute; // Filtrar solo los que NO pertenecen a la ruta
      })
      .map(order => {
      const clientBP = this.listBusinessPartner.find(bp => bp.id === order.shipTo.id);
      const clientRoutes = clientBP?.routes?.map(route => route) ?? [] ;
      
      return { 
        shipToName: order.shipTo.name, 
        serial: order.serial,
        selectedRoutes: this.prepareClientRoutes(this.routesList
          .find(r => String(r._id) === this.editOrderForm.value.route)?.routes),
        prepareClientRoutes: this.prepareClientRoutes(clientRoutes),
      };
    });
  }

  prepareClientRoutes(routes: ShortRouteAttributes[]) {
    return routes.map(route => ({
      ...route,
      displayText: this.getCode(route) ? `${this.getCode(route)} - ${route.name}` : route.name
    }));
  }

  openConfirmBPDialog(invalidOrders: any[]): void {
    this.dialog
      .open(this.confirmBpDialog, { data: { invalidOrders }, panelClass: "delete-modal", disableClose: true })
      .afterClosed()
      .subscribe((result) => {
        if (result) {

        }
      });
  }

  async updateOrder() {
    const { trip, dateDelivery, timeDelivery, route } = this.editOrderForm.value;

    // Validar campos requeridos
    if (trip && (!dateDelivery || !timeDelivery || !route)) {
      this.snackBar.open('Debe seleccionar una fecha, hora de entrega y/o ruta', 'Cerrar', { duration: 3000 });
      return;
    }

    const selectedDate = new Date(dateDelivery); const minDate = new Date(this.minDate); const maxDate = new Date(this.maxDate);
    selectedDate.setHours(0, 0, 0, 0); minDate.setHours(0, 0, 0, 0); maxDate.setHours(0, 0, 0, 0);

    // Si la fecha está fuera del rango, mostrar alerta y detener el proceso
    if (selectedDate < minDate || selectedDate > maxDate) {
      this.snackBar.open(`La fecha seleccionada está fuera del rango permitido (${minDate.toLocaleDateString()} - ${maxDate.toLocaleDateString()}).`, 'Cerrar', { duration: 3000 })
      return;
    }
    // let orderIds = [String((this.data as OrderAttributes)._id)];
    let orderIds = this.getOrderIds(this.data);

    const invalidOrders = this.getInvalidShipTo(this.data);
    if (invalidOrders.length > 0) {
      this.isOtherRoute = true;
      this.openConfirmBPDialog(invalidOrders)
      return;
    }

    await this.isValidDeliveryDay(dateDelivery); //validar day

    let dateTimeDelivery = this.getDateTime('dateDelivery', 'timeDelivery');
    let dateTimeLoad = this.getDateTime('dateLoad', 'timeLoad');

    let send: IUpdateOrder = {
      orderIds: orderIds,
      subRouteId: this.editOrderForm.value.route,
      deliveryDateTime: dateTimeDelivery ? dateTimeDelivery.toISOString() : null,
      //loadDateTime: dateTimeLoad ? dateTimeLoad.toISOString() : null,
      tripId: this.editOrderForm.value.trip ?? null
    }
    this.loadService.updateOrder(send).subscribe({
      next: () => {
        this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al actualizar registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  //filter form
  private getAllSalesOfficeList(companyId: string): void {
    this.salesOfficeService.findToComboBox(companyId).subscribe({
      next: (res) => {
        this.salesOfficeList = res.data;
        this.listFilterSalesOfficeList.update(() => this.salesOfficeList.slice());
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener  oficinas de venta.","Cerrar",{ duration: 5000});
      },
    });
  }

  changueOptionsSalesOffice(event) {
    if (!this.salesOfficeList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterSalesOfficeList.update(() => this.salesOfficeList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterSalesOfficeList.update(() => this.salesOfficeList.filter(item => item.externalKeys?.code.toLowerCase().indexOf(search) > -1 || item.name.toLowerCase().indexOf(search) > -1))
  }

  private fetchRouteGroups(companyId: string): void {
    this.routeGroupService.findByCompanyId(companyId).subscribe((res) => {
      this.routeGroup.update(() => res.data);
    });
  }

  changeSearchRoute() {
    this.listFilterRoutesList.update(() => [])

    const validData = Array.isArray(this.data) && this.data.length > 0
      ? this.data[0]
      : this.data;

    if (validData?.company?._id) {
      this.fetchRoutes(String(validData.company._id));
    }
    // this.fetchRoutes(String(this.data.company?._id))
  }

  private fetchRoutes(companyId: string): Promise<void> {
    return new Promise((resolve) => {
      this.subRouteService.findToComboBoxByCompanyAndModel(
        companyId,
        this.editOrderForm.value.salesOffice, //sales Office
        this.editOrderForm.value.routeGroup, //route Grouo
        '08'
      ).subscribe((res) => {
        this.routesList = res.data
        this.listFilterRoutesList.update(() => this.routesList.slice());
        resolve();
      });
    });
  }

  changueOptionsRoute(event) {
    if (!this.routesList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterRoutesList.update(() => this.routesList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterRoutesList.update(() => this.routesList.filter(item => item.name.toLowerCase().indexOf(search) > -1))
  }

  changeRoute() {
    this.editOrderForm.patchValue({ dateLoad: null, timeLoad: null, trip: null });
    this.fetchTrip();
  }

  async fetchTrip(): Promise<void> {
    const now = new Date();
    const nowUTC = new Date(now.getTime() - now.getTimezoneOffset() * 60000);

    let findRoute = this.listFilterRoutesList().find(ele => ele._id == this.editOrderForm.value.route);
    if (!findRoute) {
      return;
    }

    this.isOtherRoute = false;

    const res = await lastValueFrom(this.tripService.findToComboBox(findRoute.id, nowUTC, true));

    this.trips.update(() => res.data);

    if (Array.isArray(res.data) && res.data.length === 1) {
      this.editOrderForm.get('trip').setValue(res.data[0]._id);
      this.changeTrip();
    }
  }

  statusTrip() {
    this.statusList = TRIP_STATUS_LIST;
  }

  getTripStatusLabel(statusId: number): string {
    const status = this.statusList.find(s => s.code === statusId);
    return status ? status.value : 'Sin estado';
  }

  changeTrip() {
    const tripSelected = this.trips().find(trip => trip._id == this.editOrderForm.value.trip);
    if (tripSelected) {

      // 1. Validación para estado 4 
      if (tripSelected.statusTripId === StatusEnum.TRIP_IN_PROCESS) {
        this.dialog.open(this.orderDetailConfirmDialog, {
          data: { title: 'Advertencia', message: '¿Está seguro de asignarlo a un viaje en Curso?' },
          panelClass: "delete-modal",
          disableClose: true
        }).afterClosed().subscribe((confirm: boolean) => {
          if (!confirm) {
            this.editOrderForm.get('trip')?.setValue(null, { emitEvent: false }); // Resetear si cancela
            return;
          }
          this.setTripDateTime(tripSelected);
        });
      }


      let loadDateTime = tripSelected.loadDateTime ?? '';
      this.setDateTimeFromISOToForm(loadDateTime as string, 'dateLoad', 'timeLoad');

      //date
      const formatTimeLocal = (date: Date) => date.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit", hour12: false });

      this.minDate = new Date(tripSelected.dateHourStartTeoric)
      this.maxDate = new Date(tripSelected.dateHourEndTeoric)

      //hour
      this.dateDeliverySubscription?.unsubscribe();
      // Suscribirse al cambio de fecha de entrega
      this.dateDeliverySubscription = this.editOrderForm.get('dateDelivery')?.valueChanges.subscribe(selectedDate => {
        this.updateMinTime(new Date(selectedDate), tripSelected);
      });
      this.setTripDateTime(tripSelected);

    }
  }

  private setTripDateTime(tripSelected: any) {
    // Obtener la fecha teórica de inicio del viaje
    const startDate = new Date(tripSelected.dateHourStartTeoric);

    // Establecer la hora a las 6:00 AM
    startDate.setHours(6, 0, 0, 0);

    // Formatear la fecha para el datepicker
    this.editOrderForm.get('dateDelivery').setValue(startDate);

    // Formatear la hora para el timepicker (06:00)
    this.editOrderForm.get('timeDelivery').setValue('06:00');

  }

  // Método auxiliar para mostrar el diálogo
  private async showConfirmDialog(title: string, message: string): Promise<boolean> {
    const dialogRef = this.dialog.open(FuseConfirmationDialogComponent, {
      data: { title, message },
      disableClose: true
    });
    return await dialogRef.afterClosed().toPromise();
  }

  cleanDeliveryDate() {
    this.editOrderForm.get('dateDelivery').setValue(null);
    this.editOrderForm.get('timeDelivery').setValue(null);
    this.minDate = null;
    this.maxDate = null;
  }

  updateMinTime(selectedDate: Date, trip: any) {
    if (!selectedDate || !trip) return;

    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const startTime = new Date(trip.dateHourStartTeoric);
    const endTime = new Date(trip.dateHourEndTeoric);

    const today = new Date();
    const isToday = selectedDate.toDateString() === today.toDateString();

    if (isToday) {
      const nowUTC = new Date(today.getTime() - today.getTimezoneOffset() * 60000);
      //this.minTime = nowUTC.toISOString().substring(11, 16);
      this.minTime = nowUTC.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: userTimeZone });
    } else {
      //this.minTime = startTime.toISOString().substring(11, 16);
      this.minTime = startTime.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: userTimeZone });
    }

    // Asegurar que la hora máxima no sea menor que la mínima
    //this.maxTime = endTime.toISOString().substring(11, 16);
    this.maxTime = endTime.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: userTimeZone });
    if (this.maxTime < this.minTime) {
      this.maxTime = "23:59";
    }
  }

  private getAllBusinesseliveryRoutes(orderIds: number[]): void {
    const options = {
      search: null,
      currentPage: 1,
      //limitPerPage: 50,
      sortActive: "name",
      //sortDirection: "ASC"
    };

    this.businessPartnerService.findToComboDeliveryRoutes(
      options,
      orderIds,
    ).subscribe({
      next: (res: IRequestResult<BusinessPartnerAttributes[]>) => {
        this.listBusinessPartner = res.data
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener socios de negocios.","Cerrar",{ duration: 5000});
      },
    })
  }

  getOrderIds(orders: OrderAttributes): string[] {
    if (Array.isArray(orders)) {
      return this.data.map(order => String(order._id));
    }
    return [String((orders as OrderAttributes)._id)];
  }
}
